import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface RegularStudent {
  code: string;
  first_name: string;
  last_name: string | null;
  nickname: string | null;
  hours: number | null;
  weekly_scheduled_hours: number | null;
  estimated_hours_depletion_date: string | null;
  last_class_date: string | null;
  has_classes_last_30_days: boolean;
}

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export function useRegularStudents() {
  return useQuery({
    queryKey: ["regular-students"],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from("v_fishsix_students")
        .select("code, first_name, last_name, nickname, hours, weekly_scheduled_hours, estimated_hours_depletion_date, last_class_date")
        .order("hours", { ascending: true, nullsFirst: false });

      if (error) throw error;

      const now = Date.now();
      return ((data ?? []) as Omit<RegularStudent, "has_classes_last_30_days">[]).map((s) => ({
        ...s,
        has_classes_last_30_days: s.last_class_date
          ? (now - new Date(s.last_class_date).getTime()) <= THIRTY_DAYS_MS
          : false,
      })) as RegularStudent[];
    },
  });
}
